module.exports = __webpack_public_path__ + "img/chenweiwei.a8bc4b47.jpg";